module["exports"] = [
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسداسدھدسبابگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبادفھناسدھ",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدباسدفنباسد",
	"رعابھ",
	"ابسانفسدد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سندافاھگسدبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"ساسدبھ اسدفگبطاسدفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدطاسدگاسدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چاسدسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
	"سگ",
	"دگاس",
	"ساد",
	"دسھا",
	"باس",
	"نان",
	"انب",
	"ابس",
	"ادسگ",
	"ابنسد",
	"سفد",
	"دف",
	"بس",
	"باسدب",
	"باسدبا",
	"رعابھ",
	"ابسد",
	"سب",
	"ساد",
	"ط",
	"اسدبگ",
	"اسدگ",
	"اھگسد",
	"سدگ",
	"اسگ",
	"شبچ",
	"عو",
	"سدبگا",
	"اسبد",
	"ساب",
	"سدب",
	"سبا",
	"باسد",
	"دسب",
	"طسد",
	"چسد",
];
